import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Brain, ArrowRight } from "lucide-react";
import { SPORTS } from "@/data/site";

export const SportsOverview = ({ heading = "Our top sports labs" }) => (
  <section className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
    <div className="max-w-2xl">
      <span className="text-xs font-extrabold uppercase tracking-wider text-[#F97316]">
        ELC to Year 2 · Greater Melbourne
      </span>
      <h2 className="mt-2 font-head text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">
        {heading}
      </h2>
      <p className="mt-3 text-base text-slate-600">
        The top five global sports, taught through playful, science-backed coaching.
      </p>
    </div>

    <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
      {SPORTS.map((s, i) => (
        <motion.div
          key={s.slug}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.45, delay: (i % 3) * 0.08 }}
        >
          <Link
            to={`/sports/${s.slug}`}
            data-testid={`sport-card-${s.slug}`}
            className="group flex h-full flex-col overflow-hidden rounded-3xl border border-[#E2ECEE] bg-white transition-all hover:-translate-y-1.5 hover:shadow-xl"
          >
            <div className="aspect-square w-full overflow-hidden" style={{ backgroundColor: `${s.accent}10` }}>
              <img
                src={s.image}
                alt={s.name}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex flex-1 flex-col p-6 pt-5">
            <h3 className="font-head text-xl font-extrabold text-slate-900">{s.name}</h3>
            <p className="mt-1 text-sm font-bold" style={{ color: s.accent }}>{s.tagline}</p>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600">{s.intro}</p>
            <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-extrabold text-[#0E9E96]">
              Explore this lab <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </span>
            </div>
          </Link>
        </motion.div>
      ))}

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-40px" }}
        transition={{ duration: 0.45, delay: 0.16 }}
      >
        <Link
          to="/science"
          data-testid="sport-card-science"
          className="group flex h-full flex-col rounded-3xl bg-[#0B3B38] p-6 text-white transition-all hover:-translate-y-1.5 hover:shadow-xl"
        >
          <div className="grid h-24 w-24 place-items-center rounded-3xl bg-[#FACC15] text-[#5A4300] transition-transform group-hover:scale-105">
            <Brain className="h-11 w-11" />
          </div>
          <h3 className="mt-4 font-head text-xl font-extrabold">The Movement Science</h3>
          <p className="mt-1 text-sm font-bold text-[#FACC15]">Our 4-stage session flow</p>
          <p className="mt-2 flex-1 text-sm leading-relaxed text-teal-50/80">
            See exactly how a session develops the brain and body together.
          </p>
          <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-extrabold text-[#FACC15]">
            See the science <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </span>
        </Link>
      </motion.div>
    </div>
  </section>
);
